import LdSelectInput from 'lion-vue-shared/components/LdSelectInputContainer';
import { HC_PROPS, initHCProps } from '../index';

export { initHCProps, HC_PROPS };
export default LdSelectInput;
